export const translations = {
  en: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.matters': 'My Matters',
    'nav.documents': 'Documents',
    'nav.invoices': 'Invoices',
    'nav.payments': 'Payments',
    'nav.expenses': 'Expenses',
    'nav.appointments': 'Appointments',
    'nav.messages': 'Messages',
    'nav.profile': 'Profile',
    'nav.trust': 'Trust Account',
    'nav.paymentHistory': 'Payment History',
    'nav.help': 'Help & Guide',
    'nav.signOut': 'Sign Out',

    // Login
    'login.title': 'Client Portal',
    'login.signIn': 'Sign in to access your account',
    'login.resetPassword': 'Reset your password',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.emailPlaceholder': 'Enter your email',
    'login.passwordPlaceholder': 'Enter your password',
    'login.signingIn': 'Signing in...',
    'login.signInBtn': 'Sign In',
    'login.or': 'or',
    'login.googleSignIn': 'Sign in with Google',
    'login.forgotPassword': 'Forgot your password?',
    'login.backToSignIn': 'Back to sign in',
    'login.sendResetLink': 'Send Reset Link',
    'login.sending': 'Sending...',
    'login.needHelp': 'Need help? Contact your law firm for assistance.',

    // Dashboard
    'dashboard.welcome': 'Welcome back',
    'dashboard.overview': 'Overview',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.upcomingAppointments': 'Upcoming Appointments',
    'dashboard.pendingInvoices': 'Pending Invoices',
    'dashboard.activeMatters': 'Active Matters',

    // Matters
    'matters.title': 'My Matters',
    'matters.noMatters': 'No matters found',
    'matters.status': 'Status',
    'matters.type': 'Type',
    'matters.attorney': 'Attorney',

    // Documents
    'documents.title': 'Documents',
    'documents.noDocuments': 'No documents found',
    'documents.download': 'Download',
    'documents.upload': 'Upload',

    // Invoices
    'invoices.title': 'Invoices',
    'invoices.noInvoices': 'No invoices found',
    'invoices.amount': 'Amount',
    'invoices.dueDate': 'Due Date',
    'invoices.payNow': 'Pay Now',
    'invoices.paid': 'Paid',
    'invoices.pending': 'Pending',
    'invoices.overdue': 'Overdue',

    // Messages
    'messages.title': 'Messages',
    'messages.noMessages': 'No messages yet',
    'messages.startConversation': 'Start a Conversation',
    'messages.selectConversation': 'Select a conversation',
    'messages.typeReply': 'Type a reply...',
    'messages.newMessage': 'New Message',
    'messages.subject': 'Subject',
    'messages.send': 'Send Message',
    'messages.sending': 'Sending...',
    'messages.typing': 'is typing...',
    'messages.areTyping': 'are typing...',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.retry': 'Retry',
    'common.noData': 'No data available',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.all': 'All',
    'common.language': 'Language'
  },

  fil: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.matters': 'Mga Kaso',
    'nav.documents': 'Mga Dokumento',
    'nav.invoices': 'Mga Singil',
    'nav.payments': 'Mga Bayad',
    'nav.expenses': 'Mga Gastos',
    'nav.appointments': 'Mga Appointment',
    'nav.messages': 'Mga Mensahe',
    'nav.profile': 'Profile',
    'nav.trust': 'Trust Account',
    'nav.paymentHistory': 'Kasaysayan ng Bayad',
    'nav.help': 'Tulong at Gabay',
    'nav.signOut': 'Mag-sign Out',

    // Login
    'login.title': 'Client Portal',
    'login.signIn': 'Mag-sign in para ma-access ang iyong account',
    'login.resetPassword': 'I-reset ang iyong password',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.emailPlaceholder': 'Ilagay ang iyong email',
    'login.passwordPlaceholder': 'Ilagay ang iyong password',
    'login.signingIn': 'Nag-sign in...',
    'login.signInBtn': 'Mag-sign In',
    'login.or': 'o',
    'login.googleSignIn': 'Mag-sign in gamit ang Google',
    'login.forgotPassword': 'Nakalimutan ang password?',
    'login.backToSignIn': 'Bumalik sa sign in',
    'login.sendResetLink': 'Magpadala ng Reset Link',
    'login.sending': 'Nagpapadala...',
    'login.needHelp': 'Kailangan ng tulong? Makipag-ugnayan sa iyong abogado.',

    // Dashboard
    'dashboard.welcome': 'Maligayang pagbabalik',
    'dashboard.overview': 'Buod',
    'dashboard.recentActivity': 'Kamakailang Aktibidad',
    'dashboard.upcomingAppointments': 'Mga Paparating na Appointment',
    'dashboard.pendingInvoices': 'Mga Pending na Singil',
    'dashboard.activeMatters': 'Mga Aktibong Kaso',

    // Matters
    'matters.title': 'Mga Kaso Ko',
    'matters.noMatters': 'Walang nahanap na kaso',
    'matters.status': 'Status',
    'matters.type': 'Uri',
    'matters.attorney': 'Abogado',

    // Documents
    'documents.title': 'Mga Dokumento',
    'documents.noDocuments': 'Walang nahanap na dokumento',
    'documents.download': 'I-download',
    'documents.upload': 'Mag-upload',

    // Invoices
    'invoices.title': 'Mga Singil',
    'invoices.noInvoices': 'Walang nahanap na singil',
    'invoices.amount': 'Halaga',
    'invoices.dueDate': 'Takdang Petsa',
    'invoices.payNow': 'Magbayad Ngayon',
    'invoices.paid': 'Bayad Na',
    'invoices.pending': 'Pending',
    'invoices.overdue': 'Lagpas na sa Takda',

    // Messages
    'messages.title': 'Mga Mensahe',
    'messages.noMessages': 'Wala pang mensahe',
    'messages.startConversation': 'Magsimula ng Usapan',
    'messages.selectConversation': 'Pumili ng usapan',
    'messages.typeReply': 'Mag-type ng sagot...',
    'messages.newMessage': 'Bagong Mensahe',
    'messages.subject': 'Paksa',
    'messages.send': 'Ipadala',
    'messages.sending': 'Nagpapadala...',
    'messages.typing': 'nagta-type...',
    'messages.areTyping': 'nagta-type...',

    // Common
    'common.loading': 'Nag-lo-load...',
    'common.error': 'May naganap na error',
    'common.retry': 'Subukan Muli',
    'common.noData': 'Walang datos',
    'common.save': 'I-save',
    'common.cancel': 'Kanselahin',
    'common.close': 'Isara',
    'common.search': 'Maghanap',
    'common.filter': 'I-filter',
    'common.all': 'Lahat',
    'common.language': 'Wika'
  }
}

export default translations
